// Intensity director + mini-missions. Keeps the main module pruned.

export type ExcitingEventKind =
  | 'pickup_spawned'
  | 'pickup_collected'
  | 'combo_milestone'
  | 'mission_started'
  | 'mission_completed'
  | 'overdrive_started'
  | 'boss_spawned'
  | 'save_triggered'
  | 'upgrade_offered'
  | 'wave_cleared';

export interface DirectorState {
  lastExcitingAtSec: number;
  lastMajorAtSec: number;
  lastMissionAtSec: number;
}

export function makeDirector(): DirectorState {
  return {
    lastExcitingAtSec: 0,
    lastMajorAtSec: 0,
    lastMissionAtSec: 0,
  };
}

export type MissionKind =
  | 'break_bricks'
  | 'perfect_hits'
  | 'collect_pickups'
  | 'keep_combo';

export type MissionRewardKind =
  | 'pickup'
  | 'momentum'
  | 'shield'
  | 'score2x'
  | 'pulse_ready';

export interface MissionReward {
  kind: MissionRewardKind;
}

export interface Mission {
  id: string;
  kind: MissionKind;
  label: string;
  progress: number;
  target: number;
  startedAtSec: number;
  deadlineSec: number;
  reward: MissionReward;
  active: boolean;
}

interface MissionTemplate {
  kind: MissionKind;
  label: (target: number) => string;
  target: number;
  durationSec: number;
  reward: MissionReward;
}

const MISSION_POOL: readonly MissionTemplate[] = [
  {
    kind: 'break_bricks',
    label: (t) => `BREAK ${t} BRICKS`,
    target: 7,
    durationSec: 14,
    reward: { kind: 'pickup' },
  },
  {
    kind: 'perfect_hits',
    label: (t) => `${t} PERFECT HITS`,
    target: 3,
    durationSec: 18,
    reward: { kind: 'pulse_ready' },
  },
  {
    kind: 'collect_pickups',
    label: (t) => `CATCH ${t} DROPS`,
    target: 2,
    durationSec: 20,
    reward: { kind: 'pickup' },
  },
  {
    kind: 'keep_combo',
    label: (t) => `KEEP ${t}+ CHAIN`,
    target: 10,
    durationSec: 14,
    reward: { kind: 'score2x' },
  },
];

let _missionSeq = 0;
export function rollMission(now: number): Mission {
  const tpl = MISSION_POOL[(Math.random() * MISSION_POOL.length) | 0]!;
  _missionSeq += 1;
  return {
    id: `m_${_missionSeq}`,
    kind: tpl.kind,
    label: tpl.label(tpl.target),
    progress: 0,
    target: tpl.target,
    startedAtSec: now,
    deadlineSec: now + tpl.durationSec,
    reward: tpl.reward,
    active: true,
  };
}
